import {useEffect, useState} from "react";
import GithubRepo from "./GithubRepo"
import "../../data/css/github.scss"

export default function Github() {
    const [repos, setRepos] = useState();

    const formatDate = (d) => {

        let ye = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(d);
        let mo = new Intl.DateTimeFormat('en', {month: '2-digit'}).format(d);
        let da = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(d);
        const result = `${da}-${mo}-${ye}`
        console.log('new date: ', result)
        return result
    }

    useEffect(() => {
            fetch('https://api.github.com/users/panjacob/repos')
                .then(response => response.json())
                .then(data => {
                    const repo_new = data.map(repo => {
                        repo.Date = new Date(repo.updated_at)
                        repo.DateStr = formatDate(repo.Date)
                        return repo
                    }).sort((a, b) => b.Date - a.Date)
                    console.log(repo_new)
                    setRepos(repo_new)
                });
        }, []
    )// eslint-disable-line react-hooks/exhaustive-deps


    if (!repos) return <></>
    return (
        <div className={"aalp1 container container-fluid"}>
            {/*<div className={"container container-fluid"}>*/}

            <h2 className={"title pb-0 px-0 mx-0 text-center"}>My projects on GitHub</h2>
            <h5 className={"text-center px-0 mx-0 pb-5 color-gray"}>from api.github.com</h5>
            <div className={'row container'}>
                    {repos.map((repo, i) => <GithubRepo key={i} repo={repo}/>)}
            </div>
        </div>
    );


    // return (
    //     <div className={"container container-fluid w-100 aalp1"}>
    //         <h2 key={v4()} className={"title pb-0 text-center"}>About <span className={"color-special"}>me</span></h2>
    //         <h5 key={v4()} className={"text-center pb-5 color-gray"}>
    //             I'm fourth year student of computer science.<br/>
    //             I specialize in web app development.
    //         </h5>
    //         <div key={v4()} className={ "m-0 p-0 row container-fluid"}>
    //                 {repos.map((repo, i) => <GithubRepo key={i} repo={repo}/>)}
    //         </div>
    //     </div>
    // );
}


